import { API } from 'aws-amplify';

function cleanEmptyValue(obj) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === '') {
      // eslint-disable-next-line no-param-reassign
      delete obj[key];
    }
  });

  return obj;
}

export const create = async branch => API.put('cmseinkaufskreisApi', '/branches', { body: cleanEmptyValue(branch) });

export const read = async () => API.get('cmseinkaufskreisApi', '/branches', {});

export const update = async branch => API.post('cmseinkaufskreisApi', `/branches/${branch.id}`, {
  body:
    cleanEmptyValue(branch),
});

export const del = async branch => API.del('cmseinkaufskreisApi', `/branches/${branch.id}`, {});
